// extracted by mini-css-extract-plugin
export default {"Wrapper":"ProductCategoryPage_Wrapper__G4Dsw","selectedCategory":"ProductCategoryPage_selectedCategory__FdJq4"};